<template lang="pug">
v-container( fill-height pa-0)
  v-layout(sm4 align-center justify-center)
    v-card.elevation-1
      v-img( :src='customers.data.logoUrl' aspect-ratio="3")
      v-progress-linear.ma-0( :indeterminate='users.loading')
      v-toolbar.elevation-0.primary
        v-toolbar-title.white--text Iniciar Sesión

      v-card-text
        v-form(autocomplete='false')
          v-autocomplete( v-if='!$route.params.customerName' label='Seleccione su empresa' :items="customerRecord" return-object item-text='name' v-model='customers.data')
          v-text-field( label="Correo" v-model='users.email' @keypress.enter='logIn($route.params.customerName)')
          v-text-field( v-model="users.password" @keypress.enter='logIn($route.params.customerName)' :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'" :rules="[rules.required, rules.minEight]" :type="showPassword ? 'text' : 'password'" name="input-10-1" label="Contraseña" hint="Al menos 8 carácteres" counter @click:append="showPassword = !showPassword" )
      v-card-actions.justify-end
        v-btn.mr-2(:to='{name:"signUp", params: {customerName : $route.params.customerName}}'  outlined  color='primary')
          span Activar cuenta
        v-btn.mr-2(color='primary' @click='logIn($route.params.customerName)') 
          v-icon fa-sign-in-alt
      
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { mainAuth, usersCollection} from '@/FirebaseConfig.js'
  export default {
    data:()=> ({
      showPassword: false,
    }),
    methods:{
      ...mapActions({
        setCustomer: 'Customers/setCustomer',
        logIn: 'Users/logIn',
      }),      
    },
    created(){
      if(this.$route.params.customerName) {
        this.setCustomer(this.$route.params.customerName)
      }
    },
    computed:{
      ...mapGetters({
        customerRecord: 'Customers/publicRecord'
      }),
      ...mapState({
        data: state => state.Users.data,
        rules: state => state.Helpers.rules,
        users: state => state.Users,
        customers: state => state.Customers,
      })
    },
    watch: {
      '$store.state.Customers.data'(){
        this.$vuetify.theme.primary = this.$store.state.Customers.data.color
        this.$route.params.customerName = this.$store.state.Customers.data.slug
        this.$router.replace({params: {customerName: this.$store.state.Customers.data.slug}})
      },
      'customerRecord'(){
        if( this.$route.params.customerName) {
          this.$store.state.Customers.data = this.customerRecord.find(item=>item.name = this.$route.params.customerName)
          document.cookie='customerName=' + encodeURIComponent( this.$route.params.customerName )
        }

        let path = window.location.origin
        if (path === 'https://app.sermep.com.pe') {
          this.$store.state.Customers.data = this.customerRecord.filter( item => item.slug === 'sermep' )[0]
        }

      },
    },
  }

</script>
